























































































































































































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
@Component({

})

export default class Home extends Vue {
  private win = window;
  private base = window.location;

  private servicio1() {
    this.$router.push({ name: "Erradicacion" }).catch((err) => {});
  }

  private servicio2() {
    this.$router.push({ name: "Bateas" }).catch((err) => {});
  }

  private servicio3() {
    this.$router.push({ name: "Recoleccion" }).catch((err) => {});
  }

  private servicio4() {
    this.$router.push({ name: "Moviles" }).catch((err) => {});
  }
}
